// extracted by mini-css-extract-plugin
export default {"form-error":"errors-module_form-error_S8DbgiiO"};